import React, { useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import { useFormContext } from 'react-hook-form';
import { strings } from 'strings';

import UploadImage from '../../../../../../shared/Components/UploadImage/UploadImage';
import { AbsoluteImage, DropZoneContainer, Image } from '../../../../../../shared/Typhography';
import { DeleteIcon } from '../../../../../../assets/Modal';

interface UploadGameEventImageProps {
  onFileChange: (image: any | null) => void;
}

const UploadGameEventImage = ({ onFileChange }: UploadGameEventImageProps) => {
  const { getValues, formState } = useFormContext();

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/jpeg,image/png',
    onDrop: (files) => onFileChange(files[0]),
  });

  const imageSrc = useMemo(() => getValues().image, [formState]);
  if (imageSrc) {
    return (
      <div style={{ position: 'relative' }}>
        <AbsoluteImage
          top={0}
          right={0}
          left={0}
          bottom={0}
          cursor="pointer"
          src={DeleteIcon}
          alt="remove image"
          onClick={() => onFileChange(null)}
        />
        <Image
          style={{
            marginTop: '40px',
            objectFit: 'cover',
            objectPosition: 'center',
          }}
          borderRadiusType="rounded"
          src={imageSrc}
          width="100%"
          height="150px"
        />
      </div>
    );
  }

  return (
    <>
      <DropZoneContainer {...getRootProps()}>
        <input {...getInputProps()} />
        <UploadImage buttonText={strings.uploadImage} />
      </DropZoneContainer>
    </>
  );
};

export default UploadGameEventImage;
